const musixTheme = {
  colors: {
    accent: "#34338a",
    accentLight: "#D8D7FE",
  }
}

export default musixTheme;